"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WEBOS_DRM_SERVICE = 'luna://com.webos.service.drm';
var DRM_TYPE = 'playready';
var DRM_MESSAGE_TYPE = 'application/vnd.ms-playready.initiator+xml';
var DRM_SYSTEM_ID = 'urn:dvb:casystemid:19219';
var WebOSDRMAgent = (function () {
    function WebOSDRMAgent(context, appId, onError) {
        this.context = context;
        this.appId = appId;
        this.onError = onError;
    }
    WebOSDRMAgent.prototype.initialise = function (drmConfiguration) {
        var _this = this;
        if (!drmConfiguration) {
            return Promise.resolve();
        }
        return this.loadDRMClient()
            .then(function (_a) {
            var clientId = _a.clientId;
            _this.clientId = clientId;
            _this.subscribeToDRMError();
            if (drmConfiguration.customChallengeData) {
                var setCustomDataXML = _this.createSetCustomDataXML(drmConfiguration.customChallengeData);
                return _this.sendDRMMessage(setCustomDataXML);
            }
        })
            .then(function () {
            var licenseServerUriXML = _this.createLicenseServerUriXML(drmConfiguration.licenceAcquisitionUrl);
            return _this.sendDRMMessage(licenseServerUriXML);
        });
    };
    WebOSDRMAgent.prototype.close = function () {
        var _this = this;
        if (!this.clientId) {
            return Promise.resolve();
        }
        this.subscribeLicensingErrorRequest.cancel();
        return new Promise(function (resolve, reject) {
            _this.context.webOS.service.request(WEBOS_DRM_SERVICE, {
                method: 'unload',
                parameters: { clientId: _this.clientId },
                onSuccess: function (result) {
                    _this.clientId = null;
                    setTimeout(function () { return resolve(); }, 0);
                },
                onFailure: function (result) {
                    setTimeout(function () { return reject(result); }, 0);
                },
            });
        });
    };
    WebOSDRMAgent.prototype.loadDRMClient = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.drmClientRequest = _this.context.webOS.service.request(WEBOS_DRM_SERVICE, {
                method: 'load',
                parameters: {
                    drmType: DRM_TYPE,
                    appId: _this.appId,
                },
                onSuccess: function (result) {
                    setTimeout(function () { return resolve(result); }, 0);
                },
                onFailure: function (error) {
                    setTimeout(function () { return reject(error); }, 0);
                },
            });
        });
    };
    WebOSDRMAgent.prototype.sendDRMMessage = function (message) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.sendRightInformationRequest = _this.context.webOS.service.request(WEBOS_DRM_SERVICE, {
                method: 'sendDrmMessage',
                parameters: {
                    clientId: _this.clientId,
                    msgType: DRM_MESSAGE_TYPE,
                    msg: message,
                    drmSystemId: DRM_SYSTEM_ID,
                },
                onSuccess: function (result) {
                    if (result.resultCode === 0) {
                        setTimeout(function () { return resolve(); }, 0);
                    }
                    else {
                        setTimeout(function () {
                            return reject({
                                errorCode: result.resultCode,
                                errorText: result.resultMsg,
                            });
                        }, 0);
                    }
                },
                onFailure: function (result) {
                    setTimeout(function () { return reject(result); }, 0);
                },
            });
        });
    };
    WebOSDRMAgent.prototype.subscribeToDRMError = function () {
        var _this = this;
        this.subscribeLicensingErrorRequest = this.context.webOS.service.request(WEBOS_DRM_SERVICE, {
            method: 'getRightsError',
            parameters: {
                clientId: this.clientId,
                subscribe: true,
            },
            onSuccess: function (result) {
                if (result.errorState !== undefined) {
                    if (result.errorState === 0) {
                        _this.onError({
                            code: 'LG-0',
                            message: 'No license',
                            isFatal: true,
                        });
                    }
                    else if (result.errorState === 1) {
                        _this.onError({
                            code: 'LG-1',
                            message: 'Invalid license',
                            isFatal: true,
                        });
                    }
                    else {
                        _this.onError({
                            code: 'LG-XS',
                            message: 'Unknown error',
                            isFatal: true,
                        });
                    }
                }
            },
            onFailure: function (result) {
                _this.onError({
                    code: 'LG-XF',
                    message: '[' + result.errorCode + '] ' + result.errorText,
                    isFatal: true,
                });
            },
        });
    };
    WebOSDRMAgent.prototype.createSetCustomDataXML = function (customData) {
        return "<?xml version='1.0' encoding='utf-8'?>\n          <PlayReadyInitiator xmlns='http://schemas.microsoft.com/DRM/2007/03/protocols/'>\n            <SetCustomData>\n              <CustomData>" + customData + "</CustomData>\n            </SetCustomData>\n          </PlayReadyInitiator>";
    };
    WebOSDRMAgent.prototype.createLicenseServerUriXML = function (licenseServerUri) {
        return "<?xml version='1.0' encoding='utf-8'?>\n          <PlayReadyInitiator xmlns='http://schemas.microsoft.com/DRM/2007/03/protocols/'>\n            <LicenseServerUriOverride>\n              <LA_URL>" + licenseServerUri + "</LA_URL>\n            </LicenseServerUriOverride>\n          </PlayReadyInitiator>";
    };
    return WebOSDRMAgent;
}());
exports.WebOSDRMAgent = WebOSDRMAgent;
